import { BoardBasisCode } from '@libs/trip-planner-interfaces';

import type { PossibleMealFilters } from '../../model/hotelFilters';
import { HotelFilter } from '../../model/hotelFilters';

export function getMealTypeForFilter(
  code: BoardBasisCode
): PossibleMealFilters {
  switch (code) {
    case BoardBasisCode.RoomOnly:
      return HotelFilter.MealsNoMeals;
    case BoardBasisCode.Breakfast:
      return HotelFilter.MealsBreakfast;
    case BoardBasisCode.HalfBoard:
      return HotelFilter.MealsHalfBoard;
    case BoardBasisCode['HalfBoardPlus']:
      return HotelFilter.MealsHalfBoard;
    case BoardBasisCode.FullBoard:
      return HotelFilter.MealsFullBoard;
    case BoardBasisCode.AlInclusive:
      return HotelFilter.MealsAllInclusive;
  }
}
